import {
  Category,
  ImpactCo2Answer,
} from '@/domain/impact-co2/entities/question.entity';

import { QuestionAccommodationMapper } from '../questions/accommodation/mapper';
import { QuestionAccommodationPublicMapper } from '../questions/accommodation-public/mapper';
import { QuestionBuildingMapper } from '../questions/building/mapper';
import { QuestionBuildingHeatingMapper } from '../questions/building-heating/mapper';
import { QuestionCargoMapper } from '../questions/cargo/mapper';
import { QuestionCateringBeverageMapper } from '../questions/catering-beverage/mapper';
import { QuestionCateringMealMapper } from '../questions/catering-meal/mapper';
import { QuestionDigitalMapper } from '../questions/digital/mapper';
import { QuestionEnergyMapper } from '../questions/energy/mapper';
import { QuestionEquipmentMapper } from '../questions/equipment/mapper';
import { QuestionGeneratorMapper } from '../questions/generator/mapper';
import { QuestionMobilityMapper } from '../questions/mobility/mapper';
import { QuestionMobilityPublicMapper } from '../questions/mobility-public/mapper';
import { QuestionNonRecyclableWasteMapper } from '../questions/non-recyclable-waste/mapper';
import { QuestionOfficeSuppliesNewMapper } from '../questions/office-supplies-new/mapper';
import { QuestionOfficeSuppliesRefurbishMapper } from '../questions/office-supplies-refurbish/mapper';
import { QuestionRecyclableWasteMapper } from '../questions/recyclable-waste/mapper';
import { QuestionScenographyNoRecyclableMapper } from '../questions/scenography-no-recyclable/mapper';
import { QuestionScenographyRecyclableMapper } from '../questions/scenography-recyclable/mapper';
import { QuestionTeamMobilityMapper } from '../questions/team-mobility/mapper';
import { QuestionWaterMapper } from '../questions/water/mapper';

type ImportResponsesCo2Dto = {
  projectId: number;
  responses: {
    key: string;
    object: Response;
  }[];
};

type Response = {
  projectId: number;
  sector: string;
  label: string | null;
  tags?: { values?: Array<{ id: number; name: string }> };
  [key: string]: any; // specific fields (like accommodationType, numberOfNights)
};

export class ImportImpactAnswersCo2Mapper {
  static prepareResponses(
    answers: ImpactCo2Answer[],
    projectId: number,
  ): ImportResponsesCo2Dto['responses'] {
    const responses = answers.map((answer) =>
      mapImpactAnswerEntityToDto(answer, projectId),
    );
    return responses;
  }
}
function mapImpactAnswerEntityToDto(
  answer: ImpactCo2Answer,
  projectId: number,
): ImportResponsesCo2Dto['responses'][number] {
  const key = CategoryToResponseKeyMapper[answer.category];
  const entityToDto = CategoryToDtoToEntityMapper[answer.category];
  const object = entityToDto(answer, projectId);
  return { key, object };
}

const CategoryToResponseKeyMapper: Record<Category, string> = {
  ACCOMMODATION: 'accommodation',
  BUILDING: 'building',
  BUILDING_HEATING: 'building-heating',
  CARGO: 'cargo',
  CATERING_BEVERAGE: 'catering-beverage',
  CATERING_MEAL: 'catering-meal',
  DIGITAL: 'digital',
  ENERGY: 'energy',
  EQUIPMENT: 'equipment',
  GENERATOR: 'generator',
  MOBILITY: 'mobility',
  OFFICE_SUPPLIES_NEW: 'office-supplies-new',
  OFFICE_SUPPLIES_REFURBISH: 'office-supplies-refurbish',
  ACCOMMODATION_PUBLIC: 'public-accommodation',
  MOBILITY_PUBLIC: 'public-mobility',
  SCENOGRAPHY_NO_RECYCLABLE: 'scenographie-no-recyclable',
  SCENOGRAPHY_RECYCLABLE: 'scenographie-recyclable',
  TEAM_MOBILITY: 'team-mobility',
  NON_RECYCLABLE_WASTE: 'waste-non-recyclable',
  RECYCLABLE_WASTE: 'waste-recyclable',
  WATER: 'water',
};

const CategoryToDtoToEntityMapper: Record<
  Category,
  (answer: ImpactCo2Answer<any>, projectId: number) => Response
> = {
  ACCOMMODATION: QuestionAccommodationMapper.entityToDto,
  BUILDING: QuestionBuildingMapper.entityToDto,
  BUILDING_HEATING: QuestionBuildingHeatingMapper.entityToDto,
  CARGO: QuestionCargoMapper.entityToDto,
  CATERING_BEVERAGE: QuestionCateringBeverageMapper.entityToDto,
  CATERING_MEAL: QuestionCateringMealMapper.entityToDto,
  DIGITAL: QuestionDigitalMapper.entityToDto,
  ENERGY: QuestionEnergyMapper.entityToDto,
  EQUIPMENT: QuestionEquipmentMapper.entityToDto,
  GENERATOR: QuestionGeneratorMapper.entityToDto,
  MOBILITY: QuestionMobilityMapper.entityToDto,
  OFFICE_SUPPLIES_NEW: QuestionOfficeSuppliesNewMapper.entityToDto,
  OFFICE_SUPPLIES_REFURBISH: QuestionOfficeSuppliesRefurbishMapper.entityToDto,
  ACCOMMODATION_PUBLIC: QuestionAccommodationPublicMapper.entityToDto,
  MOBILITY_PUBLIC: QuestionMobilityPublicMapper.entityToDto,
  SCENOGRAPHY_NO_RECYCLABLE: QuestionScenographyNoRecyclableMapper.entityToDto,
  SCENOGRAPHY_RECYCLABLE: QuestionScenographyRecyclableMapper.entityToDto,
  TEAM_MOBILITY: QuestionTeamMobilityMapper.entityToDto,
  NON_RECYCLABLE_WASTE: QuestionNonRecyclableWasteMapper.entityToDto,
  RECYCLABLE_WASTE: QuestionRecyclableWasteMapper.entityToDto,
  WATER: QuestionWaterMapper.entityToDto,
};
